const ONE_DAY = 1000 * 60 * 60 * 24
const ONE_HOUR = 1000 * 60 * 60
export function getDaysInRetention(dateEntered: string): number {
  const diff = Math.abs(Date.now() - new Date(dateEntered).getTime())
  return Math.max(1, Math.ceil(diff / ONE_DAY))
}
export function getClaimRemainingMs(claimedAt: string): number {
  return Math.max(0, new Date(claimedAt).getTime() + ONE_HOUR - Date.now())
}
export function formatRemainingTime(claimedAt: string): string {
  const remainingMs = getClaimRemainingMs(claimedAt)
  const minutes = Math.floor(remainingMs / (1000 * 60))
  const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000)
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((part) => part[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()
}
